import React, { useEffect, useState } from 'react';
import {
  Box,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Paper,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MarkdownRenderer from '@/components/shared/MarkdownRenderer';

function EulaAcceptance({ accepted, onAcceptChange }) {
  const [eula_content, setEulaContent] = useState('');
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    const loadEula = async () => {
      try {
        const domain_suffix =
          import.meta.env.VITE_BACKEND_DOMAIN_SUFFIX ||
          import.meta.env.VITE_DOMAIN_SUFFIX ||
          '';
        const response = await fetch(`https://www.${domain_suffix}/md/eula.md`);
        const text = await response.text();
        setEulaContent(text);
      } catch (error) {
        console.error('Error loading EULA:', error);
        setEulaContent('');
      } finally {
        setLoading(false);
      }
    };

    loadEula();
  }, []);

  const handleAccept = (event) => {
    const is_accepted = event.target.checked;
    if (is_accepted) {
      const today = new Date();
      const date_string = today.toISOString().split('T')[0]; // YYYY-MM-DD format
      onAcceptChange(date_string);
    } else {
      onAcceptChange(null);
    }
  };

  const handleAccordionChange = (event, is_expanded) => {
    setExpanded(is_expanded);
  };

  return (
    <Box sx={{ mb: 3 }}>
      <Accordion
        expanded={expanded}
        onChange={handleAccordionChange}
        sx={{
          mb: 2,
          '&.Mui-expanded': {
            margin: '0 0 16px 0',
          },
        }}
      >
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <Typography variant='h6'>
            End User License Agreement (EULA)
          </Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Paper
            elevation={1}
            sx={{
              p: 3,
              mb: 3,
              backgroundColor: 'grey.50',
              border: '1px solid',
              borderColor: 'grey.200',
            }}
          >
            {loading ? (
              <Typography>Loading EULA...</Typography>
            ) : (
              <MarkdownRenderer content={eula_content} />
            )}
          </Paper>
        </AccordionDetails>
      </Accordion>
      <FormControlLabel
        required
        control={
          <Checkbox
            checked={!!accepted}
            onChange={handleAccept}
            disabled={loading}
          />
        }
        label='I accept the End User License Agreement (EULA) above.'
        sx={{ ml: 0 }}
      />
    </Box>
  );
}

export default EulaAcceptance;
